import React from 'react';
import { StyleSheet, View } from 'react-native';
import PropTypes from 'prop-types';
import ModalHalf from '@components/modal/ModalHalf';
import Image from '@components/global/Image';
import SociollaText from '@components/sociolla/SociollaText';
import Colors from '@global/colors';

const VisibilityProductNotFoundModal = ({
  visible = false,
  onClose = () => {},
}) => {
  return (
    <ModalHalf
      testID="todo-visibility-not-found-modal"
      title=""
      visible={visible}
      maxWidth="100%"
      onClose={onClose}>
      <View style={styles.productNotFoundContainer}>
        <View style={styles.productNotFoundIconContainer}>
          <Image
            style={styles.productNotFoundIcon}
            width={80}
            height={80}
            source={require('@assets/img/icons/no-product.svg')}
            svg
          />
        </View>
        <SociollaText type="medium" style={styles.productNotFoundTitle}>
          Product Not Found
        </SociollaText>
        <SociollaText style={styles.productNotFoundDescription}>
          Invalid barcode or product not found.{'\n'}
          Please try scanning again or search manually.
        </SociollaText>
      </View>
    </ModalHalf>
  );
};

const styles = StyleSheet.create({
  productNotFoundContainer: {
    padding: 30,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 250,
  },
  productNotFoundIconContainer: {
    marginBottom: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  productNotFoundIcon: {
    width: 80,
    height: 80,
    opacity: 0.8,
  },
  productNotFoundTitle: {
    fontSize: 18,
    color: Colors.grey1,
    textAlign: 'center',
    marginBottom: 12,
    letterSpacing: 0.5,
  },
  productNotFoundDescription: {
    fontSize: 14,
    color: Colors.grey2,
    textAlign: 'center',
    lineHeight: 20,
    marginBottom: 30,
    paddingHorizontal: 20,
  },
});

export default React.memo(VisibilityProductNotFoundModal);

VisibilityProductNotFoundModal.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
};
